<template>
<div id="Vue"  style="background:#eceaea;">

<el-row style="background: #fff;width:100%; height:80px" justify="space-between"> 
  <el-col :span="2"><div  ><a href="/" title="智造云"  >
                 <img  src="/static/picture/logo.png" style="height:60px;width:60px; margin-top:5px;margin-left:20px;" >
                </a> </div></el-col>
				
  <el-col :span="20" :offset="2">
  <el-menu :default-active="activeIndex"   mode="horizontal" @select="handleSelect"   >  
  <el-menu-item index="1"> <span style="font-size:16px; " >首页</span> </el-menu-item>
  <el-menu-item index="2">  <span style="font-size:16px; " >领英数据 </span></el-menu-item>
  <el-menu-item index="3"> <span style="font-size:16px; " > 邮箱验证 </span></el-menu-item>
  <el-menu-item index="20"> <span style="font-size:16px; " > HS编码查询 </span></el-menu-item>
  <el-menu-item index="4"> <span style="font-size:16px; " > 公司决策者搜索 </span></el-menu-item> 
  <el-menu-item index="5"> <span style="font-size:16px; " > 会员服务 </span></el-menu-item> 
  
  <el-submenu v-if="login_state == 1" index="6" style="float: right;text-align: right;">
  
    <template slot="title">欢迎你, {{userInfo.phone}}</template>

    <el-menu-item index="2-1"> 账户设置 </el-menu-item>
    <el-menu-item index="2-2" > 退出登录  </el-menu-item> 
     
  </el-submenu> 
  <el-menu-item index="7" v-if="login_state == 0" style="margin-left:60px "> 登录 </el-menu-item> 
  <el-menu-item index="8" v-if="login_state == 0"  > 注册  </el-menu-item> 
   
  </el-menu>
  </el-col>
 
</el-row>
  

<router-view/>
 
<bottom> </bottom>	
</div>

</template>
<style>


 
</style>

<script>
import bottom from '@/components/appFooter'
export default {
 
        data () {
            return {
	    	is_loading: false,
		    userInfo: {},
			customShow : true,
 
			login_state: 0,
 
			activeIndex: '1',
			} 
        },
		components:{bottom },
        methods: {
		  login()
			{
			  this.$router.push({
					name: 'login',
					params: {
					  requestFrom: 'customsHome'
					}
				  }); 
			},		

		

		 
          handleSelect(key, keyPath) {
              console.log(key, keyPath); 
 
			  if (key == 1 )
				  this.$router.push({
					name: 'customsIndex',
					params: {
					  sometext: ''
					}
				  });
			  if (key == 2)
				  this.$router.push({
					name: 'linkedIn',
					params: {
					  sometext: ''
					}
				  });			       
			  if (key == 3)
				  this.$router.push({
					name: 'emailCheck',
					params: {
					  sometext: ''
					}
				  });
			  if (key == 30)
				  this.$router.push({
					name: 'chatGPT',
					params: {
					  sometext: ''
					}
				  });				  
			  if (key == 4){
				  this.$router.push({
					name: 'customsContact',
					query: {
					   
					}
				  });
 
                  }				  
			  if (key == 5)	  
			       this.$router.push({
					name: 'feature',
					params: {
					  sometext: ''
					}
				    });
			  if (key == 20)	  
			       this.$router.push({
					name: 'hsCode',
					params: {
					  sometext: ''
					}
				    });		      
			  if (key == '2-1'){
				  this.$router.push({
					path: '/setting/myInfo',
					params: {
					  sometext: ''
					}
				  }); 
				  }
			  if (key == '2-2'){
                  localStorage.setItem('userInfo',  '');
				   
				  this.$router.push({
					path: '/home/index',
					params: {
					  sometext: ''
					}
				  });
				  location.reload();
				  }
              if (key == 7){
			       this.$router.push({
					name: 'login',
					params: {
					  sometext: ''
					}
				  });
				 			   
                  }
			  if (key == 8){
			       this.$router.push({
					name: 'reg',
					params: {
					  sometext: ''
					}
				    });
				  }
			  if (key == 9){
			       this.$router.push({
					name: 'customsIndex',
					params: {
					  sometext: ''
					}
				    });
				  }
                    		   
             }
		},
		created(){
            let that = this;
		    var info1 = localStorage.getItem("userInfo"); 
            var userName = '';
            var userId = 0;
            var userPhone = '';
            var userEmail = '';
            if (info1 != undefined && info1 != '' && info1 != "undefined" && info1 != null){
              var info = JSON.parse(info1);
              that.userInfo = info ;   
			  that.login_state = 1;
			  console.log(that.userInfo);
			  }else
			  {
			  console.log(info1);
			  }
		  },		
		}
</script>
 


// WEBPACK FOOTER //
// src/components/customs/customsHome.vue